import { STORE_KEYS } from '@constants'
import { saveToStorage } from '@helpers/storage.helpers'
import { Store } from '@stores'
import { action, makeAutoObservable } from 'mobx'
import { IKvkCompany } from '@api'

export class KvKStore {
  [key: string]: any
  loading: boolean
  selected: IKvkCompany | null
  searchTerm: string
  list: IKvkCompany[]
  total: number

  constructor(store: Store) {
    makeAutoObservable(this)
    this.store = store
    this.loading = false
    this.selected = null
    this.searchTerm = ''
    this.list = []
    this.total = 0
  }

  @action
  setSelectedRow = (row: IKvkCompany) => {
    this.set(STORE_KEYS.SELECTED, row)
  }

  @action
  resetSelectedRow = () => this.set(STORE_KEYS.SELECTED, null)

  @action
  handleSearchTerm = (q: string) => {
    this.searchTerm = q
  }

  @action
  searchCompany = async (query: string) => {
    if (!query || query.length < 2) {
      this.set(STORE_KEYS.LIST, [])
      this.set('total', 0)
      return
    }

    this.set(STORE_KEYS.LOADING, true)
    try {
      const response = await this.store.api.kvk.searchCompany({
        query,
        results_per_page: 10,
      })

      this.set(STORE_KEYS.LIST, response.data || [])
      this.set('total', response.total || 0)
    } catch (e) {
      console.error('KVK search error: ', e)
      this.set(STORE_KEYS.LIST, [])
      this.set('total', 0)
      this.store.ui.handleErrorToast('Fout bij zoeken in KVK')
    } finally {
      this.set(STORE_KEYS.LOADING, false)
    }
  }

  @action
  getCompanyByKvkNumber = async (kvkNumber: string): Promise<IKvkCompany | null> => {
    this.set(STORE_KEYS.LOADING, true)
    try {
      const response = await this.store.api.kvk.getCompanyByKvkNumber(kvkNumber)
      return response.data
    } catch (e) {
      console.error('KVK get company error: ', e)
      this.store.ui.handleErrorToast('Fout bij ophalen bedrijfsgegevens')
      return null
    } finally {
      this.set(STORE_KEYS.LOADING, false)
    }
  }

  @action
  set = (target: string, value: unknown, save?: boolean): unknown => {
    if (!target) return
    this[target] = value
    if (save) saveToStorage(target, value)
  }
}
